import { init, preRouteUpdateMetrics, getInstance } from '../helpers';

import useLocationChangeSync from '../../../hooks/useLocationChangeSync';

/**
 * create instance if not created already or reinitialize context on application change
 * and registers location change interceptor
 */
const usePageLoadPerformance = ({ appName }: { appName: string }) => {
  const performanceTracker = getInstance();
  if (!performanceTracker || performanceTracker?.context !== appName) {
    init({ appName });
  }
  useLocationChangeSync(preRouteUpdateMetrics);
};

export default usePageLoadPerformance;
